// extracted by mini-css-extract-plugin
export default {"button":"InfoBoxRedirectButton_button__-gQMY","text":"InfoBoxRedirectButton_text__0cOan","icon":"InfoBoxRedirectButton_icon__ub59a"};